import React from "react";
import withNavbar from "../../../common/HOC/NavbarContainerHOC";
import { withFormik, FormikProps } from "formik";
import * as Yup from "yup";
import InputWithLabel from "../../../common/form/InputWithLabel";
import BackButton from "../../../common/button/BackButton";
import SubmitButton from "../../../common/form/SubmitButton";
import { onSuccessAction, onFailAction } from "../../../../helpers/SwalCommon";
import SelectBox from "../../../common/form/SelectBox";
import { RouteComponentProps } from "react-router-dom";
import AssetCategoryService from "../../../../services/asset-category/AssetCategoryService";

interface FormValues {
  code: string;
  name: string;
  type: string;
  note: string;
}

interface OtherProps extends RouteComponentProps {}

type Props = OtherProps & FormikProps<FormValues>;

const AssetCategoryCreate: React.FC<Props> = props => {
  const { code, name, type, note } = props.values;
  const changeType = (e) => {
    props.setFieldValue("type",e)
  }
  return (
    <div className="card">
      <h4 className="card-title1 ml-3">Thêm mới danh mục tài sản</h4>
      <div className="card-body">
        <form>
          <div className="input-group">
            <InputWithLabel
              name="name"
              label="Tên tài sản"
              wrapClass="col-md-4 form-group"
              onChangeValue={props.handleChange}
              value={name}
              error={props.errors.name}
              isRequired={true}
              maxLength={255}
            />
            <InputWithLabel
              name="code"
              label="Mã "
              wrapClass="col-md-4 form-group"
              onChangeValue={props.handleChange}
              value={code}
              error={props.errors.code}
              isRequired={true}
              maxLength={255}
            />
            <SelectBox
              name="type"
              options={{
                1: "Tài sản tài liệu bán hàng",
                2: "Tài sản quà tặng"
              }}
              label="Loại tài sản"
              wrappedClass="col-md-4"
              firstOptionLabel="Chọn loại tài sản"
              onChange={changeType}
              value={type}
              error={props.errors.type}
              isRequired={true}
            />
          </div>
          <div className="input-group">
            <InputWithLabel
              name="note"
              label="Ghi chú"
              wrapClass="col-md form-group"
              onChangeValue={props.handleChange}
              value={note}
              error={props.errors.note}
            />
          </div>
          <div className="input-group d-flex justify-content-center p-5">
            <BackButton
              history={props.history}
              // url="/danh-muc-tai-san"
            ></BackButton>
            <SubmitButton onClick={props.handleSubmit}></SubmitButton>
          </div>
        </form>
      </div>
    </div>
  );
};

const RenderCreateForm = withFormik<Props, FormValues>({
  mapPropsToValues: () => ({
    code: "",
    name: "",
    note: "",
    type: ""
  }),
  validationSchema: Yup.object().shape({
    code: Yup.string().required("Mã không thể bỏ trống."),
    name: Yup.string().required("Tên không thể bỏ trống."),
    type: Yup.string().required("Loại tài sảnkhông thể bỏ trống.")
  }),
  validateOnBlur: false,
  validateOnChange: false,
  enableReinitialize: true,
  handleSubmit: async (values, { setSubmitting, props, setErrors }) => {
    setSubmitting(false);
    const service = new AssetCategoryService();
    const result = await service.store(values);
    if (result.status === 200) {
      onSuccessAction("Thêm mới danh mục tài sản!", function() {
        props.history.goBack();
      });
    } else if (result.status === 422) {
      setErrors(result.error);
    } else {
      onFailAction(result.error);
    }
  }
})(AssetCategoryCreate);

export default withNavbar()(RenderCreateForm);
